import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Moment from '../../helpers/momentUtils'
import { extendMoment } from 'moment-range'
import FlightOffersHeader from './FlightOffersHeader'
import OffersCarousel from '../../components/OffersCarousel/OffersCarousel'
import Loading from '../../components/Loading/Loading'
import callAPI from '../../helpers/callAPI'
import { tagFlightOffersPage } from '../../helpers/tag/dynamicPageview'
import config from '../../config'
import FooterButton from '../../components/FooterButton/FooterButton'
import Container from '../../components/Container/Container'
import getStaticData from '../../helpers/getStaticData'
import { updateFlightOffers } from '../../actions/flightOffers'
import { validateFlightOffers } from '../../actions/validation'

const moment = extendMoment(Moment)

class FlightOffers extends Component {
  state = {
    routes: [],
    isLoading: true,
    showInputFeedback: false,
    labels: {},
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { selectedFlights, validateFlightOffers } = this.props
    const { routes } = this.state
    if (
      prevProps.selectedFlights !== selectedFlights ||
      prevState.routes !== routes
    ) {
      const input = selectedFlights.map(x => x.routeId)
      validateFlightOffers(
        routes.reduce((routes, route) => {
          return { ...routes, [route.id]: input.indexOf(route.id) !== -1 }
        }, {})
      )
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    tagFlightOffersPage()
    const {
      selectedOutboundDate,
      selectedInboundDate,
      isSingleFlight,
      groupDetails,
      primary,
      secondary,
      isMultipleDestination,
      content,
    } = this.props
    let inboundDateRange, routeParams
    const outboundDateRange = this.getDateRange(
      selectedOutboundDate,
      config.flightOffers.daterange
    )

    if (!isSingleFlight) {
      inboundDateRange = this.getDateRange(
        selectedInboundDate,
        config.flightOffers.daterange
      )
    }
    const paxCount = this.getPaxCount(groupDetails.party)
    const outboundRouteParam = {
      origin: primary.outboundAirport.key,
      destination: primary.inboundAirport.key,
      originDepartureDate: outboundDateRange,
      adults: paxCount,
    }
    const inboundRouteParam = {
      origin: !isMultipleDestination
        ? primary.inboundAirport.key
        : secondary.outboundAirport.key,
      destination: !isMultipleDestination
        ? primary.outboundAirport.key
        : secondary.inboundAirport.key,
      originDepartureDate: inboundDateRange,
      adults: paxCount,
    }
    if (isSingleFlight) {
      routeParams = [outboundRouteParam]
    } else {
      routeParams = [outboundRouteParam, inboundRouteParam]
    }
    const routes = this.getRoutes(routeParams)
    this.setState({
      routes,
      labels: content('Select Flights'),
    })
  }

  getRouteName = routeId => {
    const { airports } = this.props
    if (!airports.length) {
      return null
    }
    const selectedAirports = routeId.split('-')
    const originAirport = airports.find(
      airport => airport.key === selectedAirports[0]
    )
    const destinationAirport = airports.find(
      airport => airport.key === selectedAirports[1]
    )

    return `${originAirport.label} - ${destinationAirport.label}`
  }

  getRoutes(routeParams) {
    const routes = []

    routeParams.forEach((routeParam, i) => {
      const id = `${routeParam.origin}-${routeParam.destination}`
      const flights = this.getFlightsByRoute(routeParam)
      const route = {
        id: id,
        origin: routeParam.origin,
        destination: routeParam.destination,
        dateRange: routeParam.originDepartureDate,
        type: i === 0 ? 'outbound' : 'inbound',
        flightOffers: flights,
      }

      routes.push(route)
    })

    return routes
  }

  getFlightsByRoute(routeParam) {
    const flights = []
    const flightOffersApiConfig = getStaticData('flightoffers')
    callAPI(
      { url: flightOffersApiConfig.url, params: routeParam },
      { ...flightOffersApiConfig.headers }
    ).then(offers => {
      offers.flightOffer &&
        offers.flightOffer.forEach(offer => flights.push(offer))

      this.setState({ isLoading: false })
      this.forceUpdate()
    })

    return flights
  }

  getDateRange(date, daysRange) {
    const start = moment(date, 'DD MMM YYYY').add(-daysRange, 'days')
    const end = moment(date, 'DD MMM YYYY').add(daysRange, 'days')
    const range = moment.range(start, end)
    return `${range.start.format('YYYYMMDD')}-${range.end.format('YYYYMMDD')}`
  }

  getPaxCount(party) {
    const maxPassengers = getStaticData('gossettings').maxflightofferpassengers
    const adults = party.find(adults => adults.key === 'adults')
    const children = party.find(children => children.key === 'children')
    const passengerCount = adults.value + children.value

    return passengerCount > maxPassengers ? maxPassengers : passengerCount
  }

  getAdditionalFlights = (routeId, direction) => {
    // extend the route date range
    const routes = [...this.state.routes]
    const selectedRoute = routes.find(route => route.id === routeId)

    if (!selectedRoute) {
      return
    }

    const dateStart = selectedRoute.dateRange.split('-')[0]
    const dateEnd = selectedRoute.dateRange.split('-')[1]
    let newDateRange = {}
    let newDate = {}

    if (direction === 'left') {
      const newDateStart = moment(dateStart).add(-1, 'days')
      newDate = newDateStart
      newDateRange = moment.range(newDateStart, dateEnd)
    }

    if (direction === 'right') {
      const newDateEnd = moment(dateEnd).add(1, 'days')
      newDate = newDateEnd
      newDateRange = moment.range(dateStart, newDateEnd)
    }

    const range = `${newDateRange.start.format(
      'YYYYMMDD'
    )}-${newDateRange.end.format('YYYYMMDD')}`
    const routeParam = {
      origin: selectedRoute.origin,
      destination: selectedRoute.destination,
      originDepartureDate: newDate.format('YYYYMMDD'),
      adults: this.getPaxCount(this.props.groupDetails.party),
    }
    selectedRoute.dateRange = range

    // get flights offer
    const flightOffersApiConfig = getStaticData('flightoffers')
    callAPI(
      { url: flightOffersApiConfig.url, params: routeParam },
      { ...flightOffersApiConfig.headers }
    ).then(offers => {
      offers.flightOffer &&
        offers.flightOffer.forEach(offer =>
          selectedRoute.flightOffers.push(offer)
        )

      this.setState({ routes })
    })
  }

  goToNextStep = () => {
    if (!this.isAllInputValid()) {
      this.setState({ showInputFeedback: true })
    } else {
      this.props.history.push('/ancillaries')
    }
  }

  isAllInputValid = () => {
    const input = { ...this.props.validation }
    return !Object.keys(input).some(x => input[x] === false)
  }

  setSelectedFlight = (flight, routeId, type) => {
    let routes = [...this.props.selectedFlights]
    const currentRoute = routes.find(route => route.routeId === routeId)
    if (!currentRoute) {
      // If there is no route, add one including the flight
      routes.push({
        routeId,
        type,
        routeName: this.getRouteName(routeId),
        flights: [flight],
      })
    } else {
      // If the route is already set with an existing selected flight
      // Then add / remove the current selected flight
      const isSelected = Boolean(
        currentRoute.flights.find(
          selectedFlight => selectedFlight.id === flight.id
        )
      )

      if (!isSelected) {
        const updatedFlights = currentRoute.flights
        updatedFlights.push(flight)
        currentRoute.flights = updatedFlights.sort((a, b) => {
          return moment
            .utc(a.departureDateTime)
            .diff(moment.utc(b.departureDateTime))
        })
      } else {
        let selectedFlightIndex
        currentRoute.flights.forEach((selectedFlight, i) => {
          if (selectedFlight.id === flight.id) {
            selectedFlightIndex = i
          }
        })
        // Remove the flight from the route
        currentRoute.flights.splice(selectedFlightIndex, 1)

        // Remove the route if the flights array is empty
        if (!currentRoute.flights.length) {
          routes = routes.filter(route => route.routeId !== routeId)
        }
      }
    }

    this.props.updateFlightOffers({
      selectedFlights: routes,
      prevSelectedFlights: routeId,
    })
  }

  render() {
    const { labels, showInputFeedback, routes, isLoading } = this.state
    const { selectedFlights, prevSelectedFlights, validation } = this.props
    return (
      <Container>
        <FlightOffersHeader
          heading={labels['Heading']}
          description={labels['Description']}
        />
        {!isLoading &&
          routes.map(route => (
            <OffersCarousel
              route={route}
              error={showInputFeedback && !validation[route.id]}
              name={this.getRouteName(route.id)}
              selectedFlights={selectedFlights}
              setSelectedFlight={this.setSelectedFlight}
              prevSelectedFlights={prevSelectedFlights}
              getAdditionalFlights={this.getAdditionalFlights}
              key={route.id}
              labels={{
                maxOutboundError:
                  labels['Max selected outbound flights message'],
                maxInboundError: labels['Max selected inbound flights message'],
                invalidInboundError: labels['Invalid inbound flight error'],
                invalidOutboundError: labels['Invalid outbound flight error'],
              }}
            />
          ))}
        {isLoading && <Loading />}
        <FooterButton
          buttonAction={() => this.goToNextStep()}
          buttonContent={labels['Ancillaries Button Label']}
          backButtonContent={labels['Return Button Label']}
          backButtonLink="/"
          iconName="arrow-right"
        />
      </Container>
    )
  }
}

FlightOffers.propTypes = {
  airports: PropTypes.array,
  selectedInboundDate: PropTypes.string,
  selectedOutboundDate: PropTypes.string,
  primary: PropTypes.object,
  secondary: PropTypes.object,
  selectedFlights: PropTypes.array,
  groupDetails: PropTypes.shape({
    groupName: PropTypes.string,
    party: PropTypes.array,
  }),
  validation: PropTypes.object,
  setSelectedFlight: PropTypes.func,
  isSingleFlight: PropTypes.bool,
  isMultipleDestination: PropTypes.bool,
  prevSelectedFlights: PropTypes.string,
  content: PropTypes.func,
  updateFlightOffers: PropTypes.func,
  validateFlightOffers: PropTypes.func,
  history: PropTypes.object,
}

const mapStateToProps = state => {
  const {
    groupDetails,
    validation: { flightOffers: flightOffersValidation },
    flightOffers,
    searchDetails,
  } = state
  return {
    groupDetails,
    validation: flightOffersValidation,
    ...flightOffers,
    ...searchDetails,
  }
}

const mapDispatchToProps = {
  updateFlightOffers,
  validateFlightOffers,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlightOffers)
